<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light">
      <a class="navbar-brand" href="/">
        <BaseIcon name="hop-icon"
                  viewBox="0 0 60 70"
                  width="32"
                  height="32"
                  cssClass="logo"></BaseIcon>
        BrewingBeer.io
      </a>

      <div class="navbar-text" >
        <ul class="navbar-icons">
          <li v-if="!loggedIn">
            <span v-on:click="showLogin = !showLogin" >login</span>
          </li>
          <li class="logged-in" v-if="loggedIn">
            <span v-if="username === 'admin'"><a href="/admin">Admin</a></span>
            <span v-else>{{username}}</span>
            <span><a v-on:click.prevent="logout" href="#">logout</a></span>
          </li>
        </ul>
      </div>
    </nav>

    <div class="tools" v-bind:class="{ active: showConfig }">
      <Config></Config>
    </div>

    <LoginModal v-on:close-modal="showLogin = false"
                v-if="showLogin">
    </LoginModal>

  </div>
</template>


<script>
    import { EventBus } from '../lib/event-bus.js';
    import Config from "./Config";
    import LoginModal from "./modals/LoginModal";

    export default {
        components: {
            Config,
            LoginModal
        },
        data() {
            return {
                showConfig: false,
                showLogin: false,
                username: 'Login',
                loggedIn: false
            }
        },
        methods: {
          logout() {
              delete localStorage.token;
              delete localStorage.username;
              EventBus.$emit('logged-in', false);
          }
        },
        beforeMount() {
            if (localStorage.username){
                this.username = localStorage.username;
                this.loggedIn = true;
            } else {
                this.loggedIn = false;
            }
            EventBus.$on('logged-in', val => {
                if (val) {
                    this.loggedIn = true;
                    this.username = localStorage.username;
                } else {
                    this.loggedIn = false;
                    this.username = null
                }
            });
        },
    }
</script>

<style scoped lang="scss">
  @import "/../assets/scss/_variablesx.scss";

  .tools {
    position: relative;
    transition: all 300ms;
    margin-top: -350px;
    height: 350px;
    opacity: 0;

    &.active {
      margin-top: 0;
      opacity: 1;
    }
  }
  .navbar {
    position: relative;
    padding-left: 0;
    padding-right: 0;
    background: $body-background;
    z-index: 100;

    .navbar-brand {
      font-size: 1.1em;
      margin: 0;
      padding-left: 1.7em;

      & > div {
        position: absolute;
        left: -5px;
        top: 10px;
      }
    }

    .navbar-text {
      font-size: .8em;
      list-style-type: none;

      .navbar-icons {
        margin: 0;
        padding: 0;

        li {
          margin-left: .3em;
          position: relative;
          top: 0;
          transition: background 300ms;
          display: inline-block;
          padding: 0 .3em;

          svg { position: absolute; }

          &.logged-in {
            & > span:first-child {
              border-right: 2px solid $gray-500;
              padding-right: .5em;
              margin-right: .5em;
            }
          }
        }
      }
    }
  }
  .config {
    padding: 1em 0;
    font-size: .8em;
  }
</style>
